import { StopeLocationDto } from 'providers/api/api';
import { Routes, Route } from 'react-router-dom';
import ModelDrawer from '../../ModelDrawer';
import { SceneProps, SceneSideDrawerRoute } from '../scene-utils';
import StopesPanelPage from '../../StopesPanelPage';
import { Model } from '../../hooks/useModelState';
import { PCNode } from '../../MineModel/Nodes';

const defaultSceneSideDrawerRoutes = (
  mdl: Model,
  path: string,
  baseUrl: string,
  currentDrawerState: boolean,
  setDrawerStateCallback: (isOpen: boolean) => void,
  onSelect: (model: Model, node: PCNode, props: SceneProps, stopeId?: string) => void,
  onHover: (stopeLocation?: StopeLocationDto) => void,
  sceneProps: SceneProps,
): SceneSideDrawerRoute[] => [
  {
    path: '*',
    isOpen: currentDrawerState,
    setIsOpen: setDrawerStateCallback,
    component: mdl && (
      <StopesPanelPage
        model={mdl}
        onSelect={onSelect}
        onHover={onHover}
        props={sceneProps}
      />
    ),
  },
];

const sideDrawerContent = (
  sceneProps: SceneProps,
  mdl: Model,
  onSelect: (model: Model, node: PCNode, props: SceneProps, stopeId?: string) => void,
  onHover: (stopeLocation?: StopeLocationDto) => void,
): JSX.Element => {
  const routes = defaultSceneSideDrawerRoutes(
    mdl,
    sceneProps.meta.path,
    sceneProps.meta.url,
    sceneProps.context.state.drawerOpen,
    sceneProps.context.actions.setDrawerOpen,
    onSelect,
    onHover,
    sceneProps,
  );

  return (
    <Routes>
      {routes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={(
            <ModelDrawer
              isOpen={route.isOpen}
              setIsOpen={route.setIsOpen}
            >
              {route.component}
            </ModelDrawer>
          )}
        />
      ))}
    </Routes>
  );
};

export default sideDrawerContent;
